import { styled } from 'styled-components'

export const InstitutionLogo = styled.a`
	img {
		max-width: 110px;
		max-height: 50px;
	}
`
